<template>
  <v-app style="background-color: #e0e0e0;background-size;">
   <v-container>
    <v-card class="form-container elevation-5">
        <!-- <v-container>
            <v-card style="background-image: linear-gradient(#e91e63, #7b1fa2);background-size:cover;height:auto">
                <v-layout row wrap style="padding-top:30px">
                    <v-flex xs12 style="text-align: center">
                       <v-avatar :size="90" style="border: 2px solid;border-color:white">
                           <img v-if="form.src != null"
                               :src=this.form.src
                             >
                             <img v-if="form.src == null"
                               src="../../assets/person.jpg"
                             >
                        </v-avatar>
                    </v-flex>
                    <v-flex xs12 style="text-align: center;padding-top:10px">
                        <input type="file" @change="onFileSelected" style="margin-left:20px !important"><br/>
                        <v-btn :loading="uploadBtn" color="grey" dark @click="upload()">
                    Upload Photo</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container> -->

      <v-card-title>
       <v-container>
           <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap style="margin-top:-25px">
            <v-flex xs12 sm12 md12>
                <v-text-field v-model="form.fullName" label="Fullname *" :rules="[rules.required]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field v-model="form.mobileNumber" label="Mobile number *" :rules="[rules.mobileno]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
                <v-text-field :readonly="true" v-model="form.email" label="Email ID"></v-text-field>
            </v-flex>

            
            <v-flex xs12 sm12 md12>
                <v-text-field v-model="form.address" label="Address"></v-text-field>
            </v-flex>
            <v-flex xs12 style="text-align:right">
                <v-btn color="error" dark @click="back()">Cancel</v-btn>
                <v-btn color="primary" :loading="btnSave" dark @click="onSubmit()">Submit</v-btn>
            </v-flex>
        </v-layout>
        </v-form>
        </v-container>
      </v-card-title>
    </v-card>
    </v-container>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
        valid: false,
        dobModel: false,
        btnSave: false,
        uploadBtn: false,

        rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
      },

      form: {
      },

      selectedFile: null,
    };
  },

  methods: {
      back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
          this.btnSave = true;
        this.axios
          .put(
            config.API + `Register/${this.$route.params.id}`,
            {
              id: this.$route.params.id,
              fullName: this.form.fullName,
              mobileNumber: this.form.mobileNumber,
              address: this.form.address
            },
          )
          .then(() => {
            this.$toaster.success("Updated Successfully");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
        this.btnSave = false;
      }
    },

    onFileSelected(event) {
      this.selectedFile = event.target.files[0]
    },

    upload() {
        this.uploadBtn = true;
      const fd = new FormData();
      fd.append("image", this.selectedFile, this.selectedFile.name);
      this.axios
        .post(config.API + `ProfilePic/${this.$route.params.id}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          //this.$toaster.success("Successfully Uploaded");
            this.$router.go(-1);
            window.location.reload();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.uploadBtn = false;
        });
    },
  },

  mounted() {
    this.axios
        .get(config.API + `Admin/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.form = res.data;
          this.selectedGender = res.data.gender;
          this.selectedStatus = res.data.maritalStatus;
          this.$Progress.finish();
        })
        .catch(err => {
          console.log(err.message);
          this.$Progress.fail();
        });
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
</style>